import { createSlice } from "@reduxjs/toolkit"

const dateSlice = createSlice({
    name: 'date_range',
    initialState: {
         date_range: null, 
        },
    reducers: {
        setDateRange: (state, action) => {
            const { date_range } = action.payload
            state.date_range = (date_range)? date_range : '0'
        },
    },
})

export const { setDateRange } = dateSlice.actions
export default dateSlice.reducer

export const selectDateRange = (state) => state.date_range.date_range
